// extracted by mini-css-extract-plugin
export default {"logo_txt":"style_logo_txt__4a8sN","container":"style_container__E71yu","img":"style_img__uf5Ze","subtitle":"style_subtitle__qUMdn"};